<template>
  <div class="user-account-container">
    <el-dropdown placement="bottom-start" trigger="hover" @command="handleCommand">
      <div class="avatar"><span class="username-text">{{userName}}</span><i class="el-icon-arrow-down"></i></div>
      <el-dropdown-menu class="user-account" slot="dropdown">
        <el-dropdown-item class="logout" command="password"><span class="name">{{passwordName}}</span></el-dropdown-item>
        <el-dropdown-item class="logout" command="logout"><span class="name">退出登录</span></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <LoginModifySetPasswordDialog @changePasswordState="changePasswordState" ref="loginModifySetPasswordDialog" />
  </div>
</template>
 
<script>
import authQuery from '@/rest/authQuery';
import authService from '@/services/authService';
import localStorageHelper from '@/helpers/localStorageHelper';
import { 
  AUTO_LOGOUT_PATH,
  HAS_PASSWORD
} from '@/helpers/constants';
import LoginModifySetPasswordDialog from '@/components/common/LoginModifySetPasswordDialog';

export default {
  name: 'userAccount',
  data() {
    return {
      passwordName: '设置密码',
      userName: ''
    };
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        localStorageHelper.removeItem(AUTO_LOGOUT_PATH);
        const authType = authService.getAuthTokenType();
        // send request to delete token on server        
        // clear localstorage token
        if (authType && authType === 'cicc') {
          authQuery.logout(this.userName).finally(() => {
            const a = document.createElement('a');
            // a.setAttribute('href', 'http://localhost:8080/#/new-login');
            // a.setAttribute('href', 'http://10.20.31.205:8018/#/new-login');
            a.setAttribute('href', 'http://inews-cicc.shannonai.com/#/new-login');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          });
        } else {
          authQuery.logout(this.userName).finally(() => {
            this.$router.push({
              path: '/new-login'
            });
          });
        }
      } else if (command === 'password') {
        this.$refs.loginModifySetPasswordDialog.openModifySetPasswordDialog({
          userName: this.userName, 
          passwordName: this.passwordName
        });
      }
    },
    changePasswordState() {
      this.passwordName = JSON.parse(localStorageHelper.getItem(HAS_PASSWORD)) ? '修改密码' : '设置密码';
    }
  },
  components: {
    LoginModifySetPasswordDialog
  },
  mounted() {
    this.userName = authService.getTopBarUserName();
    this.passwordName = JSON.parse(localStorageHelper.getItem(HAS_PASSWORD)) ? '修改密码' : '设置密码';
  }
};
</script>

<style lang="scss" scoped>
.user-account-container {
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-right: 24px;
  .avatar{
    display: flex;
    align-items: center;
    .username-text{
      margin-right: 10px;
      font-size: 14px;
      color: #ffffff;
    }
    .el-icon-arrow-down{
      color: #ffffff;
      font-weight: 900;
    }
  }
  /deep/ {
    i.user.icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      margin-right: 4px;
      background-image: url('./../../assets/img/user.svg');
      background-size: 100% 100%;
      cursor: pointer;
    }
  } 
}
</style>

<style lang="scss">
.el-dropdown-menu.user-account {
  width: 130px;
  padding: 8px 0;
  border: none;
  border-radius: 2px;
 /deep/ .el-dropdown-menu__item { 
    padding: 0 15px;
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    color: #464d6c;
    &:hover {        
      color: #ffffff;
      background-color: #45a8cc;
      border-radius: 0;
    } 
  }
  .popper__arrow{
    display: none;
    }
}
</style>

